import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import img from './img.png';

function Comment() {
    const { t } = useTranslation('gift');
    return (
        <Container spacing={32}
            fullWidth
            align='center'>
            <GiftImage src={img}
                width={224}
                height={112} />
            <Text size='4xl' fontWeight='bold'>
                {t('giftOrderComplete.comment')}
            </Text>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 48px 0 42px 0
`;

const GiftImage = styled(Image)`
    margin-left: 30px;
`;

export default Comment;
